/* Copyright 2013 - 2024 Waiterio LLC */
/** @jsx jsx */
import React from 'react'
import { useQuery } from '@tanstack/react-query'
import { useNavigate, useParams } from 'react-router-dom'
import { jsx, css } from '@emotion/react'
import getRestaurant from '@waiterio/api-client/getRestaurant.js'
import colMd10 from '@waiterio/styles/bootstrap/colMd10.js'
import colLg8 from '@waiterio/styles/bootstrap/colLg8.js'
import container from '@waiterio/styles/bootstrap/container.js'
import row from '@waiterio/styles/bootstrap/row.js'
import locales from '../locales.js'

export const paths = locales.map(locale => ({
  path: `/takeaway/${locale}/restaurant-:restaurantId`,
  props: {
    locale,
  },
}))

export const Head = props => {
  const { restaurantId } = useParams()

  const { data: restaurant } = useQuery({
    queryKey: ['restaurants', restaurantId],
    queryFn: () =>
      getRestaurant(restaurantId).catch(() => {
        /* DO NOTHING ON PURPOSE */
      }),
  })

  const title = restaurant?.name
  const description = restaurant?.name

  return (
    <>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
    </>
  )
}

const siteHeading = css`
  color: white;
  padding: 200px 0 150px;
  text-align: center;
  @media (min-width: 768px) {
    padding: 200px 0;
  }
`

const siteTitle = css({
  display: 'block',
  lineHeight: '46px',
  fontSize: 40,
  margin: 0,
  '@media (max-width: 767px)': {
    fontSize: 34,
  },
})

// const orderNowButton = css({
//   display:'flex',
//   justifyContent:'center',
//   lineHeight:'26px',
//   fontSize:24,
//   fontWeight:300,
//   marginTop:50,
// })

const overlay = css({
  position: 'absolute',
  left: 0,
  top: 0,
  height: '100%',
  width: '100%',
  backgroundColor: 'rgb(33, 37, 41)',
  opacity: 0.5,
})

const RestaurantPage = props => {
  const { restaurantId } = useParams()
  const navigate = useNavigate()

  const { data: restaurant } = useQuery({
    queryKey: ['restaurants', restaurantId],
    queryFn: () =>
      getRestaurant(restaurantId).catch(() => {
        navigate('/takeaway')
      }),
  })

  return (
    <header css={{ position: 'relative', maxHeight: 500 }}>
      <div css={overlay} />
      <div css={container}>
        <div css={row}>
          <div
            css={[colMd10, colLg8, { marginLeft: 'auto', marginRight: 'auto' }]}
          >
            <div css={siteHeading}>
              <h2 css={siteTitle}>{restaurant?.name}</h2>
              {
                // <div css={orderNowButton}>
                //   <div css={{fontSize: 16, border: '1px solid #fff', borderRadius: 5, margin: 5, padding:15}}>
                //     Order Now
                //   </div>
                // </div>
              }
            </div>
          </div>
        </div>
      </div>
    </header>
  )
}

export default RestaurantPage
